<template>
  <div>
    Page Not Found :(
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>